var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};


/**
 * Backbone view to handle events for the proposal toolbar
 *
 * @class     Curriculog.ProposalForm.Toolbar
 * @augments  CurriculogView
 * @todo      This should eventually also render the toolbar
 */
Curriculog.ProposalForm.Toolbar = (function ($, _, Backbone, Toolbar) {

    Toolbar = Curriculog.CurriculogView.extend({
        el: '#curriculog-fields-column-toolbar',

        events: {
            'click #curriculog-view-proposal.active, #disabled-crosslisting-btn': 'stopEvent',
            'click #curriculog-view-map': 'showProgramMap',
            'click .curriculog-parent-widget': 'goToParent',
            'click #curriculog-impact-widget': 'impactReport',
            'click #curriculog-import-widget': 'import',
            'click #curriculog-launch-widget': 'launch',
            'click #show-help-text': 'help',
            'click #curriculog-print-widget': 'print',
            'click #expand-form': 'expand'
        },

        initialize: function(options) {
            Curriculog.CurriculogView.prototype.initialize.apply(this, arguments);
            this.proposal = options.proposal;
            this.print_popup = null;
            this.map_popup = null;
            this.hermes_popup = null;
            this.cui_enabled = options.cui_enabled;
        },

        /**
         * The launch button event handler
         *
         * @param  {Event} [event]
         */
        launch: _.debounce(function(event) {
            this.stopEvent(event);
            var proposal = this.proposal;
            var that = this;

            $.when(proposal.displayOriginatorTrackingWarning(true)).done(function() {
                that.resetSplitView();
                that.addMask(proposal.$el, 'Validating...', 65);

                proposal.saveAll({
                    noMask: true
                }).done(_.bind(that.validateLaunch, that));
              }
            );
        }, 1000, true),

        /** Fires all launch validations then attempts a launch */
        validateLaunch: function() {
            var proposal = this.proposal;
            // TDOD: Move validation into the model. That will require an ajax validation library

            var validationPromises = _.flatten([
                proposal.validateFields(),
                proposal.validateConditionalSteps(),
                proposal.validateParticipants(),
                proposal.validateCrosslisting(),
                proposal.validateAssessments()
            ]);

            $.when.apply($, validationPromises).done(function(){
                proposal.removeMask(proposal.$el);
                proposal._launch.apply(proposal, arguments);
            });
        },

        /**
         * Opens the impact report popup
         *
         * @param  {Event} event
         */
        impactReport: function(event) {
            this.stopEvent(event);

            var prefix_field = this.proposal.getSystemRequiredField('coursePrefix'),
                code_field = this.proposal.getSystemRequiredField('courseCode'),
                unlaunched = this.proposal.model.get('status') == 'unlaunched',
                error = '';

            if (unlaunched && (!prefix_field.getDisplayValue() || !code_field.getDisplayValue())) {
                error = 'Prefix and Code are required for an Impact Report. ' +
                    'Please complete the required information and run the report again.';
            } else if (!unlaunched && (prefix_field.hasUnsavedChanges() || code_field.hasUnsavedChanges())) {
                error = 'You have unsaved changes to the Prefix/Code field. ' +
                    'These fields are required for an Impact Report. Please save your ' +
                    'changes and run the report again.';
            }

            if (error) {
                new Curriculog.WarningDialog({
                    message: error
                });
                return;
            }

            this._open_hermes_popup();
            // Only save all on unlaunched proposals
            if (this.proposal.model.get('status') == 'unlaunched') {
                this.proposal.saveAll().done(_.bind(this._open_impact_popup, this));
            } else {
                this._open_impact_popup();
            }
        },

        /** Opens the impact report popup */
        _open_impact_popup: function() {
            var prefix = this.proposal.model.get_prefix(),
                code = this.proposal.model.get_code();

            this.hermes_popup.location('/hermes', {
                display: 'hermesProposalImpactReport',
                method: 'impact',
                prefix: prefix,
                code: code
            });
        },

        /**
         * Import Button click event. Saves all fields so the program type is
         * saved, thens begins the import process.
         *
         * @param  {Event} event
         * Note: "import" is a reserved keyword, so js linters require it to be quoted.
         */
        'import': function(event) {
            this.stopEvent(event);

            var program_type = this.proposal.getProgramType(),
                program_field = this.proposal.getSystemRequiredField('programType'),
                unsaved_program_type = program_field && program_field.hasUnsavedChanges(),
                proposal_type = this.proposal.model.get('type');

            // If program and no program type is selected
            if (proposal_type == 'program' && program_type == -1 && !unsaved_program_type) {
                new Curriculog.WarningDialog({
                    title: 'Please select a program type',
                    message: 'You must select a program type before importing into this proposal.'
                });
                return;
            }

            this._open_hermes_popup();

            this.proposal.saveAll().done(_.bind(this._open_import_popup, this));
        },

        /**
         * Utility that keeps track of the hermes popup and only allows one open at a time.
         *
         */
        _open_hermes_popup: function() {
            if (this.hermes_popup && !this.hermes_popup.isClosed()) {
                this.hermes_popup.location('/hermes/?display=loading');
                this.hermes_popup.focus();
            } else {
                // Open the popup to a loading/waiting screen while the fields are being saved.
                // We open this now rather than waiting until save completes because if we wait,
                // the popup will be blocked by the browser because it wasnt opened by the same
                // 'thread'.
                this.hermes_popup = new Curriculog.PopupWindow({url: '/hermes/?display=loading'});
            }
        },

        /**
         * Opens the import popup
         */
        _open_import_popup: function() {
            var programType = this.proposal.getProgramType(),
                proposalType = this.proposal.model.get('type'),
                apID = this.proposal.model.get('approvalProcessId');

            if (proposalType == 'course') {
                programType = undefined;
            } else {
                programType = programType == 1 ? 'sharedcores' : 'program';
            }

            var url_params = {
                display: 'hermesAvailableLegend',
                method: 'proposal',
                systemItemId: apID,
                type: proposalType,
                id: 0,
                proposalId: this.proposal.model.id,
                subType: programType
            };

            this.hermes_popup.location('/hermes', url_params);
        },

        /**
         * Opens the proposal print popup
         *
         * @param  {Event} [event]
         */
        print: function(event) {
            if (!this.cui_enabled) {
              this.stopEvent(event);
              if (this.print_popup && !this.print_popup.isClosed()) {
                  this.print_popup.reload().focus();
                  return;
              }

              this.print_popup = new Curriculog.PopupWindow({
                  url: '/proposal:' + this.proposal.model.id + '/print',
                  width: 800,
                  height: 500
              });
            }

        },

        /**
         * The event function for the help expando button
         *
         * @param  {Event} [event]
         */
        help: function(event) {
            this.stopEvent(event);

            var $btn = $('#show-help-text'),
                proposal = this.proposal;
                showHelp = !proposal.model.get('showHelp');

            proposal.model.set('showHelp', showHelp);

            if (showHelp) {
                $btn.addClass('active');
                // field help is always shown when cui is enabled
                if (!this.cui_enabled) {
                  proposal.$form.find('.help').slideDown(200, function () {
                      Backbone.trigger('form:stretch');
                  });
                } else {
                  // but we should still reveal the proposal form help text
                  proposal.$form.find('#help-user').slideDown(200);
                }

            } else {
                $btn.removeClass('active');
                if (!this.cui_enabled) {
                  proposal.$form.find('.help').slideUp(200, function () {
                      Backbone.trigger('form:stretch');
                  });
                } else {
                  proposal.$form.find('#help-user').slideUp(200);
                }

            }
        },

        /**
         * Navigates back to the parent proposal
         *
         * @param  {Event} event
         */
        goToParent: function(event) {
            this.stopEvent(event);
            location.href = '/proposal:' + this.proposal.model.get('parentId') + '/form';
        },

        /**
         * Opens a program map popup
         *
         * @param   {Event} event
         */
        showProgramMap: function(event) {
            this.stopEvent(event);
            if (this.map_popup && !this.map_popup.isClosed()) {
                this.map_popup.reload().focus();
                return;
            }

            this.map_popup = new Curriculog.PopupWindow({
                url: '/proposal:' + this.proposal.model.id + '/map?display=popupMap',
                name: 'Proposal Map',
                width: 800,
                height: 500
            });
        },

        /**
         * Expand or contract the proposal form to full width
         *
         * @param  {Event} [event]
         */
        expand: function(event) {
            this.stopEvent(event);
            this.proposal.$el.toggleClass('full-width');
            $('#curriculog-steps-column').toggleClass('full-width');
            Backbone.trigger('form:stretch');
        },

        /*
         * Puts the form into split column mode if it is not.
         *
         */
        resetSplitView: function(event) {
            this.stopEvent(event);
            if ($('#curriculog-fields-column').hasClass('full-width')) {
                this.expand();
            }
        }

    });

    return Toolbar;
})($, _, Backbone, Curriculog.ProposalForm.Toolbar || {});
